import {
  Component,
  EventEmitter,
  Inject,
  Injector,
  OnInit,
  Output,
} from "@angular/core";
import { TUI_NUMBER_FORMAT, TuiDialogService } from "@taiga-ui/core";
import { PolymorpheusComponent } from "@tinkoff/ng-polymorpheus";
import { NgxSpinnerService } from "ngx-spinner";
import { EventDataService } from "src/app/core/services/event-data.service";
import { ApiService } from "src/app/core/services/shared/api.service";
import { GlobalVarService } from "src/app/core/services/shared/global-var.service";

import { NgxTippyProps } from "ngx-tippy-wrapper";
import {
  Answer,
  ConfigMapService,
  FormResponse,
  Searchconfig,
} from "virtue-form";
import { AwardletterpopupComponent } from "../shared/dialog/awardletterpopup/awardletterpopup.component";
import {
  Analyzeupload,
  collegeIpedsCost,
  combinedAid,
  DropdownResult,
  getCollegeProfile,
  getCollegeWiseProgramData,
  selectUniversity,
  sendSelectedUniversityData,
  Summary,
} from "./../../core/models/interest-top5";
import {
  IntrestPageAnswer,
  stateAnswer,
} from "./../../core/models/answerMapModel";
import { PredefineArrayListService } from "src/app/core/services/shared/predefine-array-list.service";
import {
  residenceOptionsCompare,
  housingOption,
} from "src/app/core/models/predefineArrayListModel";
import { Router } from "@angular/router";
import { CommonHandlerService } from "src/app/core/services/shared/common-handler.service";
@Component({
  selector: "app-comparecolleges",
  templateUrl: "./comparecolleges.component.html",
  styleUrls: ["./comparecolleges.component.scss"],
  providers: [
    {
      provide: TUI_NUMBER_FORMAT,
      useValue: { decimalSeparator: ".", thousandSeparator: "," },
    },
  ],
})
export class ComparecollegesComponent implements OnInit {
  selectedCollgesStateRequestList: Array<getCollegeProfile> = [];
  selectedUniversityList: any = [];
  viewImgPdfArray: any[] = [];
  colors = ["ff6600", "05299E", "5E4AE3", "947BD3", "F26CA7"];
  // selectedUniversityList: Array<getCollegeProfile> = [];
  efcFieldValue = [];
  stateAllList: Array<Searchconfig> = [];
  domesileStatus: string[] = [];
  year: number;
  yearWiseAffinityQuestion: any = [];
  showuploadButton = [false, undefined, undefined, undefined, undefined];
  setToggleIn = [false, undefined, undefined, undefined, undefined];
  autoRedirectToResultPage: boolean = true;
  isLoading: boolean = true;
  mergerdUniversityList: Array<DropdownResult> = []; // new variable
  @Output() optionData = new EventEmitter<any>();
  interestPageAnswerMap: Map<string, IntrestPageAnswer> = new Map();
  handleNextBtnDisable: boolean = false;
  answerMap: Map<Number, Answer> = new Map();
  affinityQuestionAnswer: Map<string, any> = new Map();
  StateInOutMap: Map<string, stateAnswer> = new Map();
  studentInputdata: any;
  ocrResponseListTotal: Array<Analyzeupload> = [];
  SearchCollegeFilterList: Array<selectUniversity> = []; // new variable
  selectedUniversityCSSProfile: any[] = [];

  selectedUniversityStateGrant: any = [];
  stateGrantFieldValue: any = [];

  residenceOptions: Array<residenceOptionsCompare>;
  housingNotAvailableOption: Array<housingOption>;
  housingAvailableOption: Array<housingOption>;

  tippyPropsLeft = {
    placement: "top-start",
    arrow: false,
    theme: "light",
  };
  tippyProps = {
    placement: "top",
    arrow: true,
    theme: "light",
  };
  public baseProps: NgxTippyProps = {
    arrow: true,
    theme: "light",
  };

  templateRef: NgxTippyProps = {
    ...this.baseProps,
    allowHTML: true,
    appendTo: "parent",
    interactive: true,
    interactiveBorder: 50,
  };

  passInnerHTML: NgxTippyProps = this.templateRef;

  constructor(
    private configmap: ConfigMapService,
    private spinnerService: NgxSpinnerService,
    private eventDataService: EventDataService,
    public apiService: ApiService,
    private predefineArray: PredefineArrayListService,
    private apiservice: ApiService,
    public globalvar: GlobalVarService,
    private commonHandler: CommonHandlerService,
    private router: Router,

    @Inject(TuiDialogService) private readonly dialogService: TuiDialogService,
    @Inject(Injector) private readonly injector: Injector
  ) {
    this.answerMap = this.globalvar.answerMap;

    this.residenceOptions = this.predefineArray.residenceOptionsCompare;
    this.housingNotAvailableOption =
      this.predefineArray.housingNotAvailableOptionCompare;
    this.housingAvailableOption =
      this.predefineArray.housingAvailableOptionCompare;
  }

  ngOnInit(): void {
    let year = new Date().getFullYear();
    this.year = year;

    if (
      this.globalvar?.top5SubscriptionDashboardRequestData?.top5_request == true
    ) {
      if (this.globalvar.autoRedirect == false) {
        this.autoRedirectToResultPage = false;
      }
      if (
        this.globalvar.top5SubscriptionDashboardRequestData?.SelectCollege == ""
      ) {
        this.apiservice.getTop5SubmissionsbyFormFilledId(
          this.globalvar.top5SubscriptionDashboardRequestData?.formfilledId,
          (resp) => {
            if (resp.extraData) {
              let data = JSON.parse(resp.extraData);
              this.selectedCollgesStateRequestList = data?.SelectCollege;

              let filterSelected = JSON.parse(
                data?.answerMapCollegeFiltersFilter
              );
              this.globalvar.filterSelected = new Map(filterSelected);

              let Reciprocity = this.globalvar.filterSelected.get(
                "reciprocityStateCodes"
              );
              if (Reciprocity && Reciprocity?.list.length > 0) {
                this.globalvar.ReciprocitySelectedStateList = Reciprocity.list;
              }
              this.getAnswerMapFromID(
                this.globalvar.top5SubscriptionDashboardRequestData
                  ?.formfilledId
              );
            }
          }
        );
      }
    } else {
      this.selectedCollgesStateRequestList =
        this.globalvar.top5SubscriptionDashboardRequestData?.selectedColleges;
      this.getAnswerMapFromID(
        this.globalvar.top5SubscriptionDashboardRequestData?.formfilledId
      );
    }
    // this.apiservice
    // .getTop5SubmissionsbyFormFilledId(this.globalvar.top5SubscriptionDashboardRequestData?.formfilledId)
    // .then((response: FormResponse) => {
  }

  getAnswerMapFromID(formFilledId: string) {
    this.apiservice
      .getFormFilled(formFilledId)
      .then((response: FormResponse) => {
        const ans = response.answers;
        ans.forEach((element) => {
          //  element.configId = "";
          this.answerMap.set(element.fieldNo, element);
          if (element?.configId) {
            if (element?.configId != "high_school") {
              this.setConfigOptions(element?.configId, element?.fieldNo);
            }
          }
        });
        this.globalvar.answerMap = this.answerMap;
        this.studentInputdata = this.answerMap.get(6);
        this.getStateList();
      });
  }

  next() {
    this.sendSelectedUniversityData();
    let pno = 8;
    this.globalvar.change(Number(pno));
    this.router.navigate(["/home/steps/" + Number(pno)]);
    this.eventDataService.hanleAnswerMap(this.answerMap);
  }

  setConfigOptions(configId: string, fieldNo: number) {
    this.configmap.getConfigData(
      configId,
      fieldNo,
      (resp: Array<Searchconfig>) => {
        this.configmap.configMap.set(configId, resp);
      },
      this.globalvar.isTokenLogin
    );
  }

  checkIsReciprocityState(statecode: string, index: number) {
    const checkRepocityState = this.globalvar.ReciprocitySelectedStateList.some(
      (selectedItem) => selectedItem === statecode.toLowerCase()
    );
    if (
      checkRepocityState == true &&
      this.domesileStatus[index] == "OUT_STATE"
    ) {
      return true;
    } else {
      return false;
    }
  }

  selectUniversity(selectedUniversity: any) {
    this.spinnerService.show();

    for (
      let index = 0;
      index < this.selectedCollgesStateRequestList.length;
      index++
    ) {
      const element = selectedUniversity[index];

      this.apiservice
        .getCollegeProfileById(element.ipedsId)
        .then((universityList) => {
          this.selectedUniversityList[index] = universityList;
          this.apiService.getCollegeProfileIcon(
            universityList.ipedsId,
            (resp) => {
              if (resp.status == 0 || resp.status == 200) {
                this.selectedUniversityList[index].collegeProfileIcon =
                  resp.url;
                this.selectedUniversityList[index].imageAvailable = true;
                this.selectedUniversityList[index].defaultLabelColor = "";
              } else {
                this.selectedUniversityList[index].collegeProfileIcon = "";
                this.selectedUniversityList[index].imageAvailable = false;
                this.selectedUniversityList[index].defaultLabelColor =
                  this.AddRandonColor();
                // } else {
                //   // this.checkIconStatus()
                //   this.selectedUniversityList[index].collegeProfileIcon =
                //     "https://cdn.virtueanalytics.com/cache/college-icon-top5.png";
                // }
              }
            }
          );

          this.selectedCollgesStateRequestList[index].control =
            universityList.control;
          this.selectedCollgesStateRequestList[index].hbcuCollege =
            universityList.hbcuCollege;

          //   this.setCollegeProfileData(universityList);
          this.SearchCollegeFilterList[index] = universityList;
          const stateList = this.stateAllList.filter(
            (item) => item.value == element.stateCode.toLowerCase()
          );
          this.selectedCollgesStateRequestList[index]["stateName"] =
            stateList[0]["label"];
          this.selectedCollgesStateRequestList[index]["collegeName"] =
            this.selectedUniversityList[index].name;

          let yearWiseAffinityQuestion = this.checkAffinityYearWiseAvailable(
            this.selectedUniversityList[index].yearWiseAffinityQuestion
          );
          if (yearWiseAffinityQuestion.length > 0) {
            this.setAffinityQuestionDefaultAnswer(
              yearWiseAffinityQuestion,
              index
            );
            this.yearWiseAffinityQuestion[index] = yearWiseAffinityQuestion;
          } else {
            this.yearWiseAffinityQuestion[index] = [];
          }
          // if (
          //   this.selectedUniversityList[index].yearWiseAffinityQuestion &&
          //   this.selectedUniversityList[index].yearWiseAffinityQuestion["2022"]
          // ) {
          //   this.setAffinityQuestionDefaultAnswer(
          //     this.selectedUniversityList[index].yearWiseAffinityQuestion[
          //       "2022"
          //     ],
          //     index
          //   );
          //   this.yearWiseAffinityQuestion[index] =
          //     this.selectedUniversityList[index].yearWiseAffinityQuestion[
          //       "2022"
          //     ];
          // } else {
          //   this.yearWiseAffinityQuestion[index] = [];
          // }

          if (
            this.selectedUniversityList[index]?.usingCSSProfile &&
            element?.usingCSSProfile &&
            element?.calculatedAids
          ) {
            const obj = {
              AffinityQuestionSelectedOption: "no",
              eligibility:
                "This college uses CSS profile for SAI calculation, please enter your CSS SAI.",
              label:
                "This college uses CSS profile for SAI calculation, please enter your CSS SAI.",
              options: [],
              terms: "",
            };
            // this.selectedUniversityList[index]["result"] =
            // element?.calculatedAids;
            this.selectedUniversityCSSProfile[index] = [obj];
            this.efcFieldValue[index] = element?.usingCSSProfile;
            // this.cdRef.detectChanges();
          } else {
            this.selectedUniversityCSSProfile[index] = [];
          }

          this.showuploadButton[index] = true;
          if (element?.awardLetterResultId) {
            this.uploadAwardletter(element?.awardLetterResultId, index);
          }

          if (element?.collegeSelections) {
            this.selectedUniversityList[index]["StudentSelectedCollege"] =
              element?.collegeSelections;
            if (
              element?.collegeSelections?.universityWiseStateGrant.length > 0
            ) {
              this.selectedUniversityStateGrant[index] =
                element.collegeSelections.universityWiseStateGrant;
              this.stateGrantFieldValue[index] =
                element.collegeSelections.universityWiseStateGrant[0].amount;
            } else {
              this.selectedUniversityStateGrant[index] = undefined;
              this.stateGrantFieldValue[index] = undefined;
              // this.selectedUniversityList[index]["StudentSelectedCollege"] = undefined;
            }
          }

          this.selectDomicileAndResidency(
            "residencyDropdown",
            index,
            element?.domicileAndResidency,
            element
          );
          this.checkToggleInOutState(index);
          this.spinnerService.hide();
        });
    }
  }
  lastAssignedColorIndex: number = -1;
  AddRandonColor() {
    let color = "#";
    let randomColorIndex = this.lastAssignedColorIndex;
    while (randomColorIndex === this.lastAssignedColorIndex) {
      randomColorIndex = Math.floor(Math.random() * this.colors.length);
    }
    this.lastAssignedColorIndex = randomColorIndex;
    return color + this.colors[randomColorIndex];
  }
  getFirstAndLastWords(str) {
    let result = "";
    const words = str.split("-");
    if (words.length >= 2) {
      const zeroindexvalue = words[0];
      const space = zeroindexvalue.split(" ");
      let lastElement = space[space.length - 1];
      result = words[0].charAt(0) + lastElement.charAt(0);
      return result;
    } else {
      const firstLetters = str.split(" ");
      let lastElement = firstLetters[firstLetters.length - 1];
      result = words[0].charAt(0) + lastElement.charAt(0);
    }
    return result;
  }
  checkAffinityYearWiseAvailable(yearWiseAffinityQuestion: any) {
    let yearWiseAffinity: any = [];
    if (
      yearWiseAffinityQuestion &&
      yearWiseAffinityQuestion[this.year] != undefined
    ) {
      yearWiseAffinity = yearWiseAffinityQuestion[this.year];
    } else {
      if (
        yearWiseAffinityQuestion &&
        yearWiseAffinityQuestion[this.year - 1] != undefined
      ) {
        yearWiseAffinity = yearWiseAffinityQuestion[this.year - 1];
      }
    }

    return yearWiseAffinity;
  }

  getAffinityQuestionYear(yearWiseAffinityQuestion: any) {
    let year: number = 0;
    if (
      yearWiseAffinityQuestion &&
      yearWiseAffinityQuestion[this.year] != undefined
    ) {
      year = this.year;
    } else {
      if (
        yearWiseAffinityQuestion &&
        yearWiseAffinityQuestion[this.year - 1] != undefined
      ) {
        year = this.year - 1;
      }
    }

    return year;
  }

  getControlType(type: string) {
    if (type == "PUBLIC") {
      return "Public";
    }
    if (type == "PRIVATE_FOR_PROFIT") {
      return "Private";
      // return "Private, for-profit";
    }
    if (type == "PRIVATE_NON_PROFIT") {
      return "Private";
      // return "Private, non-profit";
    }
  }
  uploadAwardletter(id: string, index: number) {
    this.apiservice.getUploadedAwardLetter(id).then((resp) => {
      this.ocrResponseListTotal[index] = resp;
      this.viewImgPdfArray[index] = resp;
    });
  }

  viewAwardLetter(id: string) {
    if (id) {
      let awardLetter = this.globalvar.getHost() + "fileStorage/download/" + id;
      return awardLetter;
    }
  }

  checkToggleInOutState(index: number) {
    let checked: boolean = false;

    const element = this.selectedCollgesStateRequestList[index];
    let compuseObj = this.residenceOptions.filter(
      (item) => item.domicileAndResidency == element?.domicileAndResidency
    );

    if (compuseObj[0].InOutState == "true") {
      // this.setToggleIn[index] = true;
      // checked = true;
      return true;
    } else {
      // this.setToggleIn[index] = false;
      // checked = false;
      return false;
    }
  }

  checkedIfState(fieldType: string, index: number) {
    let checked: boolean = false;
    if (fieldType == "domicileToggle") {
      let getStateAnswerMap = this.StateInOutMap.get("state" + index);
      if (getStateAnswerMap) {
        if (
          getStateAnswerMap.stateCode == this.studentInputdata.value &&
          getStateAnswerMap.stateInOut != "OUT_STATE"
        ) {
          // this.setToggleIn[index] = true;
          // checked = true;
          return true;
        } else if (
          getStateAnswerMap.stateCode != this.studentInputdata.value &&
          getStateAnswerMap.stateInOut != "OUT_STATE"
        ) {
          // this.setToggleIn[index] = true;
          // checked = true;
          return true;
        } else {
          // this.setToggleIn[index] = false;
          // checked = false;
          return false;
        }
      }

      // return checked;
    }
  }

  // getCampusOption(index: number) {
  //   if (this.selectedUniversityList[index]) {
  //     let campusOption = [];
  //     const element = this.selectedCollgesStateRequestList[index];
  //     let compuseObj = this.residenceOptions.filter(
  //       (item) => item.value == element?.domicileAndResidency
  //     );
  //     campusOption.push(compuseObj);
  //     return this.residenceOptions;
  //   }
  // }

  getCampusOption(index: number) {
    let options = [];
    if (
      this.selectedUniversityList[index] &&
      this.selectedUniversityList[index]?.housingNotAvailable == true
    ) {
      options = this.housingNotAvailableOption;
    } else {
      options = this.housingAvailableOption;
    }
    return options;
  }
  setAffinityQuestionDefaultAnswer(
    AffinityQuestionDefaultAnswer: any,
    uIndex: number
  ) {
    let totalamt = 0;
    for (let index = 0; index < AffinityQuestionDefaultAnswer.length; index++) {
      let affinity;
      if (
        this.selectedCollgesStateRequestList[uIndex]?.affinityQuestions !=
        undefined
      ) {
        affinity =
          this.selectedCollgesStateRequestList[uIndex]?.affinityQuestions[
            index
          ];
        affinity.options.forEach((element) => {
          if (element.selected == true) {
            totalamt += element.amount;
          }
        });
        this.changeAffinityQuestionOption(
          "SetAnswer",
          uIndex,
          index,
          affinity.AffinityQuestionSelectedOption,
          totalamt,
          affinity
        );
      } else {
        if (
          this.selectedCollgesStateRequestList[uIndex]?.affinityQuestion !=
          undefined
        ) {
          affinity =
            this.selectedCollgesStateRequestList[uIndex]?.affinityQuestion[
              index
            ];
          affinity.options.forEach((element) => {
            if (element.selected == true) {
              totalamt += element.amount;
            }
          });
          this.changeAffinityQuestionOption(
            "SetAnswer",
            uIndex,
            index,
            affinity.AffinityQuestionSelectedOption,
            totalamt,
            affinity
          );
        }
      }
    }
  }

  changeAffinityQuestionOption(
    type: string,
    index: number,
    option: number,
    optionSelected: any,
    totalammount: number,
    options: any
  ) {
    if (type == "SetAnswer") {
      this.setInterestPageAnswer(
        "aq" + index + "-" + option,
        optionSelected,
        [],
        ""
      );
      optionSelected = optionSelected;
    }

    let year = this.getAffinityQuestionYear(
      this.selectedUniversityList[index].yearWiseAffinityQuestion
    );
    if (year) {
      this.selectedUniversityList[index].yearWiseAffinityQuestion[year][
        "AffinityQuestionSelectedOption"
      ] = optionSelected;
      this.selectedUniversityList[index].yearWiseAffinityQuestion[year][option][
        "AffinityQuestionSelectedOption"
      ] = optionSelected;
      this.selectedUniversityList[index].yearWiseAffinityQuestion[year][option][
        "AffinityQuestionSelectedAmount"
      ] = totalammount;

      this.selectedUniversityList[index].yearWiseAffinityQuestion[year][
        "AffinityQuestionSelectedAmount"
      ] = totalammount;
    }
  }

  getAcceptanceRate(ipedsId: string, index: string) {
    let admissionsRate = 0;
    if (this.selectedUniversityList[index]) {
      if (
        this.selectedUniversityList[index].ipedsId == ipedsId &&
        this.selectedUniversityList[index]?.CollegeWiseProgramList
          ?.admissionsRate
      ) {
        admissionsRate = Math.ceil(
          Number(
            this.selectedUniversityList[index]?.CollegeWiseProgramList
              ?.admissionsRate
          ) * 100
        );
      }
    }
  }
  getAcceptanceRate1(ipeds: number, index: string) {
    let admissionsRate = 0;
    if (
      this.selectedUniversityList[index]?.CollegeWiseProgramList?.ipedsROIData
        ?.acceptanceRate
    ) {
      admissionsRate = Math.ceil(
        Number(
          this.selectedUniversityList[index]?.CollegeWiseProgramList
            ?.ipedsROIData?.acceptanceRate
        ) * 100
      );
    }
    return admissionsRate;
  }

  getAffinityQustionAnswerMap(index: number, option: number, curData: any) {
    let aindex = "aq" + index + "-" + option;
    this.affinityQuestionAnswer.set(aindex, curData);
    this.affinityQuestionAnswer = new Map(this.affinityQuestionAnswer);
    this.globalvar.affinityQuestionAnswer = this.affinityQuestionAnswer;
  }

  setInterestPageAnswer(
    index: string,
    selectedValue: string,
    list: any,
    selectedLabel: any
  ) {
    let ans = {
      defaultLabel: selectedLabel,
      defaultValue: selectedValue,
      list: list,
    };
    this.interestPageAnswerMap.set(index, ans);
    this.interestPageAnswerMap = new Map(this.interestPageAnswerMap);
    this.globalvar.interestPageAnswerMap = this.interestPageAnswerMap;
  }

  selectDomicileAndResidency(
    fieldType: string,
    index: number,
    domesileStatus: string,
    element: any
  ) {
    this.spinnerService.show();
    this.handleNextBtnDisable = true;
    let ipedsId: string;

    if (fieldType === "residencyDropdown") {
      let compuseObj = this.residenceOptions.filter(
        (item) => item.domicileAndResidency == domesileStatus
      );
      this.domesileStatus[index] =
        compuseObj[0].InOutState == "true" ? "IN_STATE" : "OUT_STATE";
      this.setInterestPageAnswer("r" + index, compuseObj[0].value, [], "");
      ipedsId = this.selectedUniversityList[index]["id"];
      this.apiservice.getCollegeIpedsCost1(
        ipedsId,
        domesileStatus,
        this.selectedUniversityList[index].stateCode,
        (res) => {
          // this.selectedUniversityList[index]["ipedsCost"] = res["costs"];
          this.selectedUniversityList[index]["IPEDS_NPCCost"] = res;

          this.selectedUniversityList[index]["ipedsCost"] = res.IPEDS["costs"];
          this.selectedUniversityList[index]["npcCost"] = res.NPC["costs"];
          this.hideSpinner();
          this.handleNextBtnDisable = false;
        }
      );

      if (this.selectedUniversityList[index].ipedsId == ipedsId) {
        if (element?.usingCSSProfile && element?.calculatedAids) {
          this.selectedUniversityList[index].selectedcssProfile =
            element?.usingCSSProfile;
          this.selectedUniversityList[index]["result"] =
            element?.calculatedAids;
          this.setByCourseCollegeWiseProgramList(index, ipedsId);
        } else {
          this.getMeritScholarShipCombindData(index, ipedsId, domesileStatus);
          this.setByCourseCollegeWiseProgramList(index, ipedsId);
        }
      }
    }
  }

  getMeritScholarShipCombindData(
    collegeIndex: number,
    ipedsId: string,
    domicileAndResidencyStatus: string
  ) {
    let efc = this.answerMap.get(40);
    // let act = this.answerMap.get(202);
    let gpa = "";
    let gpaScale = this.answerMap.get(266);
    let actdropdown = this.answerMap.get(32);
    let act = "";
    let sat = "";
    if (actdropdown.value == "act") {
      let scoreact = this.answerMap.get(202);
      act = scoreact.value;
    }
    if (actdropdown.value == "sat") {
      let scoresct = this.answerMap.get(201);
      sat = scoresct.value;
    }
    if (gpaScale.value == "4") {
      let gpaValue = this.answerMap.get(31);
      gpa = gpaValue.value;
    }
    if (gpaScale.value == "5") {
      // let gpaValue = this.answerMap.get(271);
      let gpaValue = this.answerMap.get(274);
      gpa = gpaValue.value;
    }
    if (gpaScale.value == "12") {
      let gpaValue = this.answerMap.get(275);
      gpa = gpaValue.value;
    }
    if (gpaScale.value == "100") {
      let gpaValue = this.answerMap.get(276);
      gpa = gpaValue.value;
    }
    let state = this.answerMap.get(6);
    let domesileStatus = this.domesileStatus[collegeIndex];
    this.apiservice
      .getMeritScholarShipCombindData(
        ipedsId,
        efc.value,
        act,
        sat,
        gpa,
        gpaScale?.value,
        state.value,
        domicileAndResidencyStatus,
        this.domesileStatus[collegeIndex]
      )
      .then((meritData) => {
        this.selectedUniversityList[collegeIndex]["result"] = meritData;
        this.selectedUniversityList[collegeIndex]["result"].preferOutStateGrid =
          domesileStatus == "OUT_STATE" ? true : false;
        this.hideSpinner();
        this.handleNextBtnDisable = false;
        //  return meritData;
      });
  }

  // setByCourseCollegeWiseProgramList(index: number, ipedsId: string) {
  //   let studentProgram = this.answerMap.get(35);
  //   this.apiservice.getCollegeIpedsWiseAllProgramData(ipedsId, studentProgram.value).
  //     then((ProgramList: any) => {
  //       // if (ProgramList?.collegeDataPresent == true) {
  //       // this.selectedUniversityList[index]["CollegeWiseProgramList"]=ProgramList;
  //       if (ProgramList?.id == null) {
  //         this.selectedUniversityList[index]["CollegeWiseProgramList"] = ProgramList;

  //         this.selectedUniversityList[index]["ROIDataCollegeWiseAllProgram"] = null;
  //       }
  //       else {
  //         if (ProgramList?.courseCategoryCIPCodeToProgramWiseROIDataMap) {
  //           this.selectedUniversityList[index]["CollegeWiseProgramList"] = ProgramList;
  //           this.selectedUniversityList[index]["ROIDataCollegeWiseAllProgram"] = ProgramList?.courseCategoryCIPCodeToProgramWiseROIDataMap;

  //         }
  //       }

  //       this.hideSpinner();
  //     }, (error) => {
  //       if (error.status == "500" || error.status) {
  //         this.selectedUniversityList[index]["CollegeWiseProgramList"] = null;
  //         this.selectedUniversityList[index]["ROIDataCollegeWiseAllProgram"] = null;

  //         console.log(
  //           "ROIDataCollegeWiseAllProgram :" + this.selectedUniversityList[index]["ROIDataCollegeWiseAllProgram"]
  //         );
  //       }
  //       this.hideSpinner();
  //     }
  //     );

  //   if (
  //     this.autoRedirectToResultPage == true &&
  //     this.selectedCollgesStateRequestList.length ==
  //     this.selectedUniversityList.length
  //   ) {
  //     this.redirectToResultPage();
  //     this.autoRedirectToResultPage = false;
  //     this.globalvar.autoRedirect = false;
  //   }
  // }

  setByCourseCollegeWiseProgramList(index: number, ipedsId: string) {
    let studentProgram = this.answerMap.get(35);
    // if (studentProgram.value != "0") {
    this.apiservice.getCollegeWiseProgramData1(
      ipedsId,
      studentProgram.value,
      (ProgramList) => {
        if (ProgramList?.collegeDataPresent == true) {
          this.selectedUniversityList[index]["CollegeWiseProgramList"] =
            ProgramList;
        }
        // this.IsLoadData = false;
        this.hideSpinner();
      }
    );
    // } else {
    //   this.hideSpinner();
    // }
    if (
      this.autoRedirectToResultPage == true &&
      this.selectedCollgesStateRequestList.length ==
        this.selectedUniversityList.length
    ) {
      this.redirectToResultPage();
      this.autoRedirectToResultPage = false;
      this.globalvar.autoRedirect = false;
    }
  }

  hideSpinner() {
    return setTimeout(() => {
      return this.spinnerService.hide();
    }, 1000);
  }

  redirectToResultPage() {
    return setTimeout(() => {
      this.isLoading = false;
      return this.next();
    }, 2000);
  }

  getStateList() {
    this.apiservice.getAllStateList((stateAllList: Array<Searchconfig>) => {
      this.stateAllList = stateAllList;
      this.selectUniversity(this.selectedCollgesStateRequestList);
    });
  }
  checkIconStatus(collegeIcon: string): string {
    return collegeIcon ===
      "https://cdn.virtueanalytics.com/cache/college-icon-top5.png"
      ? "custom-icon"
      : "";
  }

  getAcceptanceRateResult(ipeds: string, index: number) {
    let admissionsRate = 0;
    if (
      this.selectedUniversityList[index].ipedsId == ipeds &&
      this.selectedUniversityList[index]?.CollegeWiseProgramList?.ipedsROIData
        ?.acceptanceRate
    ) {
      admissionsRate = Number(
        this.selectedUniversityList[index]?.CollegeWiseProgramList?.ipedsROIData
          ?.acceptanceRate
      );
    }
    return admissionsRate;
  }

  getCollegeROIData(roiData: any) {
    let yearWiseData: any = [];
    if (roiData && roiData[this.year] != undefined) {
      yearWiseData = roiData[this.year];
    } else {
      if (roiData && roiData[this.year - 1] != undefined) {
        yearWiseData = roiData[this.year - 1];
      }
    }

    return yearWiseData;
  }

  sendSelectedUniversityData() {
    this.mergerdUniversityList = [];
    let searchExtraCollegeList = [];
    let searchCollege = [];
    if (
      this.selectedUniversityList.length > 5 ||
      this.selectedUniversityList.length <= 5
    ) {
      for (
        let index: number = 0;
        index < this.selectedUniversityList.length;
        index++
      ) {
        if (this.selectedUniversityList[index] == undefined) continue;
        let obj = {} as any;
        let dropDownDataObject = {} as any;
        if (this.selectedUniversityList[index]["collegeRankInUS"]) {
          obj.collegeRankInUS =
            this.selectedUniversityList[index]["collegeRankInUS"];
        }
        obj.id = this.selectedUniversityList[index]["id"];
        obj.name = this.selectedUniversityList[index]["name"];
        obj.StudentSelectedCollege =
          this.selectedUniversityList[index]["StudentSelectedCollege"];

        if (
          this.selectedUniversityList[index]["ROIDataCollegeWiseAllProgram"] !=
          undefined
        ) {
          obj.ROIDataCollegeWiseAllProgram =
            this.selectedUniversityList[index]["ROIDataCollegeWiseAllProgram"];
        } else {
          obj.ROIDataCollegeWiseAllProgram = null;
        }
        obj.IPEDSNPC = this.selectedUniversityList[index]["IPEDS_NPCCost"];
        obj.ipedsId = this.selectedUniversityList[index]["ipedsId"];
        obj.costOfAttendance = this.selectedUniversityList[index]["ipedsCost"];
        obj.npcCollegeCostProfile =
          this.selectedUniversityList[index]["npcCost"];

        obj.result = this.selectedUniversityList[index]["result"];

        if (
          this.selectedUniversityList[index].selectedcssProfile != undefined
        ) {
          obj.cssProfileEFC =
            this.selectedUniversityList[index]?.selectedcssProfile;
        }

        if (searchExtraCollegeList.length > 0) {
          if (searchCollege.length == 0) {
            searchCollege = searchExtraCollegeList;
            obj.searchExtraCollegeList = searchCollege;
          }
        }

        if (
          this.selectedUniversityList[index]["CollegeWiseProgramList"] !=
          undefined
        ) {
          obj.CollegeWiseProgramList =
            this.selectedUniversityList[index]["CollegeWiseProgramList"];
        }
        let domicileAndResidency =
          this.selectedCollgesStateRequestList[index].domicileAndResidency;
        obj.yearWiseAffinityQuestion =
          this.selectedUniversityList[index]["yearWiseAffinityQuestion"];
        for (const item of this.selectedUniversityList[index]["ipedsCost"]) {
          obj[item.name] = item.value;
        }

        if (
          this.selectedUniversityList[index]["analysisData"] != null &&
          this.selectedUniversityList[index]["analysisData"]
        ) {
          this.selectedUniversityList[index]["analysisData"].admissionsRate =
            this.getAcceptanceRateResult(
              this.selectedUniversityList[index].ipedsId,
              index
            );

          Object.entries(
            this.selectedUniversityList[index]["analysisData"]
          ).map((entry) => {
            let key = entry[0];
            let value = entry[1];
            obj[key] = value;
            if (key == "yearWiseCollegeROIData" && value) {
              let yearWiseData = this.getCollegeROIData(value);
              value["year"] = yearWiseData;
              if (
                this.selectedUniversityList[index]["analysisData"]
                  .admissionsRate
              ) {
                value["year"].admissionsRate =
                  this.selectedUniversityList[index][
                    "analysisData"
                  ].admissionsRate;
                // value["2022"].admissionsRate =this.selectedUniversityList[index]["analysisData"].admissionsRate;
                obj[key] = value;
              } else {
                //  value["year"]=yearWiseData;
                value["year"].admissionsRate = 0;
                // value["2022"].admissionsRate = 0;
                obj[key] = value;
              }
            }
          });
        } else {
          let ROIDataObj = JSON.stringify(
            this.predefineArray.yearWiseCollegeROIDataObj
          );

          let yearData = JSON.parse(ROIDataObj);
          yearData["year"].admissionsRate = this.getAcceptanceRateResult(
            this.selectedUniversityList[index].ipedsId,
            index
          );

          obj.yearWiseCollegeROIData = yearData;
        }

        dropDownDataObject = { dropDownData: obj };
        this.mergerdUniversityList[index] = dropDownDataObject;

        let objSummary = {} as any;
        //let summaryDataObject = {} as any;

        if (
          this.selectedUniversityList[index].selectedcssProfile != undefined
        ) {
          objSummary.cssProfileEFC =
            this.selectedUniversityList[index]?.selectedcssProfile;
        }
        objSummary.collegeProfileIcon =
          this.selectedUniversityList[index]?.collegeProfileIcon;
        objSummary.imageAvailable =
          this.selectedUniversityList[index]?.imageAvailable;
        objSummary.defaultLabelColor =
          this.selectedUniversityList[index]?.defaultLabelColor;
        objSummary.lastSupportedSession =
          this.selectedUniversityList[index]["lastSupportedSession"];
        objSummary.dataCollectionTime =
          this.selectedUniversityList[index]["dataCollectionTime"];

        if (this.selectedUniversityList[index]?.importantLink?.npc) {
          objSummary.npcLink =
            this.selectedUniversityList[index]["importantLink"]["npc"];
        } else {
          objSummary.npcLink = null;
        }
        if (this.selectedUniversityList[index]?.importantLink?.financialAid) {
          objSummary.financialAid =
            this.selectedUniversityList[index]["importantLink"]["financialAid"];
        } else {
          objSummary.financialAid = null;
        }

        if (this.selectedUniversityList[index]?.importantLink?.website) {
          objSummary.website =
            this.selectedUniversityList[index]["importantLink"]["website"];
        } else {
          objSummary.website = null;
        }

        if (this.selectedUniversityList[index]?.contact?.contactNumber) {
          objSummary.contact =
            this.selectedUniversityList[index]["contact"]["contactNumber"];
        } else {
          objSummary.contact = null;
        }
        if (this.selectedUniversityList[index]?.contact?.address) {
          objSummary.address =
            this.selectedUniversityList[index]["contact"]["address"];
        } else {
          objSummary.address = null;
        }

        let year = this.commonHandler.getyearWiseCollegeData(
          this.selectedUniversityList[index]?.yearWiseCollegeData,
          this.year
        );

        if (
          this.selectedUniversityList[index]?.yearWiseCollegeData ==
          ({} as object)
        ) {
          objSummary.inStateTutionFee = null;
          objSummary.outStateTutionFee = null;
          objSummary.basedOnCollegeWebsite = 0;
        } else {
          if (
            !this.selectedUniversityList[index]["yearWiseCollegeData"] ||
            !this.selectedUniversityList[index]["yearWiseCollegeData"][year]
          ) {
            objSummary.basedOnCollegeWebsite = this.setBasedOnWebsiteAmount(
              this.selectedUniversityList[index]["datafields"],
              domicileAndResidency
            );

            const data51 = this.selectedUniversityList[index][
              "datafields"
            ].find((element) => element.fieldNo == 51);
            if (data51) {
              objSummary.inStateTutionFee = data51["value"];
            }
            const data = this.selectedUniversityList[index]["datafields"].find(
              (element) => element.fieldNo == 135
            );
            if (data) {
              objSummary.outStateTutionFee = data["value"];
            }

            // objSummary.npcCOA = this.selectedUniversityList[index][
            //   "datafields"
            // ].find((element) => element.fieldNo == 50)["value"];

            // if (this.domesileStatus[index] == "IN_STATE") {
            //   objSummary.basedOnCollegeWebsite = objSummary.npcCOA;
            // } else {
            //   if (
            //     this.domesileStatus[index] == "OUT_STATE" &&
            //     objSummary.inStateTutionFee &&
            //     objSummary.outStateTutionFee
            //   ) {
            //     objSummary.basedOnCollegeWebsite =
            //       objSummary.npcCOA -
            //       (objSummary.inStateTutionFee - objSummary.outStateTutionFee);
            //   }
            // }
          } else {
            if (
              this.selectedUniversityList[index] &&
              this.selectedUniversityList[index]["yearWiseCollegeData"] !=
                ({} as object) &&
              this.selectedUniversityList[index]["yearWiseCollegeData"][year]
            ) {
              objSummary.basedOnCollegeWebsite = this.setBasedOnWebsiteAmount(
                this.selectedUniversityList[index]["yearWiseCollegeData"][year],
                domicileAndResidency
              );

              const data51 = this.selectedUniversityList[index][
                "yearWiseCollegeData"
              ][year].find((element) => element.fieldNo == 51);
              if (data51) {
                objSummary.inStateTutionFee = data51["value"];
              }
              const data = this.selectedUniversityList[index][
                "yearWiseCollegeData"
              ][year].find((element) => element.fieldNo == 135);
              if (data) {
                objSummary.outStateTutionFee = data["value"];
              }

              // const data2 = this.selectedUniversityList[index][
              //   "yearWiseCollegeData"
              // ][year].find((element) => element.fieldNo == 50);
              // if (data2) {
              //   objSummary.npcCOA = data2["value"];
              // }

              // if (this.domesileStatus[index] == "IN_STATE") {
              //   objSummary.basedOnCollegeWebsite = objSummary.npcCOA;
              // } else {
              //   if (
              //     this.domesileStatus[index] == "OUT_STATE" &&
              //     objSummary.inStateTutionFee &&
              //     objSummary.outStateTutionFee
              //   ) {
              //     objSummary.basedOnCollegeWebsite =
              //       objSummary.npcCOA -
              //       (objSummary.inStateTutionFee -
              //         objSummary.outStateTutionFee);
              //   }
              // }
              // if (this.domesileStatus[index]) {
              //   objSummary.outStateTutionFee = data["value"];
              // }
            }
          }
        }

        // summaryDataObject = { "summaryData": objSummary };
        // this.mergerdUniversityList[index] = summaryDataObject;
        this.mergerdUniversityList[index]["summaryData"] = objSummary;
      }
    }
    for (let index = 0; index < this.ocrResponseListTotal.length; index++) {
      let ocrDataScholarshipItems = {} as any;
      let ocrDataCoaItems = {} as any;
      let additionOfDetectedScholarshipValues: number = 0;
      let additionOfDetectedCoaValues: number = 0;
      let additionOfDetectedScholarshipValuesEdited: number = 0;
      let additionOfDetectedCoaValuesEdited: number = 0;
      let totalCoaIndex = -1;
      let totalAidIndex = -1;
      if (this.ocrResponseListTotal[index] == undefined) continue;
      //if(this.ocrResponseListTotal[index]){ }
      ocrDataCoaItems = this.createOcrDataObject(
        this.ocrResponseListTotal[index],
        "1"
      );
      ocrDataScholarshipItems = this.createOcrDataObject(
        this.ocrResponseListTotal[index],
        "2"
      );

      totalCoaIndex = this.ocrResponseListTotal[index][
        "detectedValues"
      ].findIndex((elem) => {
        return elem.fieldId == 501;
      });
      totalAidIndex = this.ocrResponseListTotal[index][
        "detectedValues"
      ].findIndex((elem) => {
        return elem.fieldId == 601;
      });
      if (totalCoaIndex > -1 || totalAidIndex > -1) {
        additionOfDetectedScholarshipValuesEdited =
          this.ocrResponseListTotal[index]["detectedValues"][totalAidIndex]
            .value;
        additionOfDetectedCoaValuesEdited =
          this.ocrResponseListTotal[index]["detectedValues"][totalCoaIndex]
            .value;
      } else {
        for (const item of this.ocrResponseListTotal[index]["detectedValues"]) {
          if (item.mapWith === "1") {
            additionOfDetectedCoaValues += +item.value;
          } else if (item.mapWith === "2") {
            additionOfDetectedScholarshipValues += +item.value;
          }
        }
      }
      for (
        let indexMerged = 0;
        indexMerged < this.mergerdUniversityList.length;
        indexMerged++
      ) {
        if (this.mergerdUniversityList[indexMerged] == undefined) continue;
        if (
          ocrDataScholarshipItems.id ===
          this.mergerdUniversityList[indexMerged]["dropDownData"].id
        ) {
          if (ocrDataCoaItems != undefined) {
            this.mergerdUniversityList[indexMerged]["ocrDataCoaItems"] =
              ocrDataCoaItems;
          }

          this.mergerdUniversityList[indexMerged]["ocrDataScholarshipItems"] =
            ocrDataScholarshipItems;
          this.mergerdUniversityList[indexMerged]["ocrDataCoaSum"] =
            additionOfDetectedCoaValues;
          this.mergerdUniversityList[indexMerged]["ocrDataScholarshipsSum"] =
            additionOfDetectedScholarshipValues;
          this.mergerdUniversityList[indexMerged]["ocrDataCoaSumEdited"] =
            additionOfDetectedCoaValuesEdited;
          this.mergerdUniversityList[indexMerged][
            "ocrDataScholarshipsSumEdited"
          ] = additionOfDetectedScholarshipValuesEdited;
          this.mergerdUniversityList[indexMerged]["ocrDataOutOfPocketEdited"] =
            additionOfDetectedCoaValuesEdited -
              additionOfDetectedScholarshipValuesEdited >
            0
              ? additionOfDetectedCoaValuesEdited -
                additionOfDetectedScholarshipValuesEdited
              : 0;
        }
      }
    }

    if (this.mergerdUniversityList.length > 5) {
      let mergedStr = JSON.stringify(this.mergerdUniversityList);
      searchExtraCollegeList = JSON.parse(mergedStr);
      this.mergerdUniversityList.splice(5, this.mergerdUniversityList.length);
      searchExtraCollegeList.splice(0, 5);
      this.mergerdUniversityList[0].SearchCollegeFilterList =
        searchExtraCollegeList;
    } else {
      if (this.mergerdUniversityList.length <= 5) {
        this.mergerdUniversityList[0].SearchCollegeFilterList = [];
      }
    }
    let mergerdUniversityListOnlyNotEmpty = this.mergerdUniversityList.filter(
      (element) => element != null && "null"
    );

    this.optionData.emit(mergerdUniversityListOnlyNotEmpty);
  }
  getyearWiseCollegeData(yearWiseCollegeData: any) {
    let year = 0;
    if (yearWiseCollegeData && yearWiseCollegeData[this.year] != undefined) {
      year = yearWiseCollegeData[this.year];
    } else {
      if (
        yearWiseCollegeData &&
        yearWiseCollegeData[this.year - 1] != undefined
      ) {
        year = yearWiseCollegeData[this.year - 1];
      }
    }

    return year;
  }

  createOcrDataObject(ocrDataItem, mapIdValue: string) {
    let obj = {} as sendSelectedUniversityData;
    let selectedUniversityItem = this.selectedUniversityList.find(
      (item) => item != undefined && item.name == ocrDataItem.extraText
    );
    obj.id = selectedUniversityItem["id"];
    obj.name = selectedUniversityItem["name"];
    obj.ipedsId = selectedUniversityItem["ipedsId"];
    if (
      ocrDataItem["detectedValues"].some((item) => item.mapWith === mapIdValue)
    ) {
      for (const item of ocrDataItem["detectedValues"]) {
        if (item.mapWith === mapIdValue) {
          obj[item.fieldName] = item.value;
        }
      }
    }
    return obj;
  }

  setBasedOnWebsiteAmount(collegeData: any, residenceInOutState: string) {
    let collegeWebsiteAmount = 0;
    const inStateTutionFee = collegeData.find(
      (element) => element?.fieldNo == 51
    );
    const outStateTutionFee = collegeData.find(
      (element) => element?.fieldNo == 135
    );
    const coa = collegeData.find((element) => element?.fieldNo == 50);
    const roomAndBoardFee = collegeData.find(
      (element) => element?.fieldNo == 136
    );

    if (
      (residenceInOutState == "IN_STATE_ON_CAMPUS" ||
        residenceInOutState == "IN_STATE_OFF_CAMPUS_NOT_FAMILY") &&
      coa?.value
    ) {
      collegeWebsiteAmount = coa?.value;
    }
    // if(residenceInOutState=="IN_STATE_OFF_CAMPUS_NOT_FAMILY" && coa?.value && roomAndBoardFee?.value)
    // {
    //   collegeWebsiteAmount=coa.value;
    // }
    if (
      residenceInOutState == "IN_STATE_OFF_CAMPUS_FAMILY" &&
      coa?.value &&
      roomAndBoardFee?.value
    ) {
      collegeWebsiteAmount =
        Number(coa?.value) - Number(roomAndBoardFee?.value);
    }
    if (
      (residenceInOutState == "OUT_STATE_ON_CAMPUS" ||
        residenceInOutState == "OUT_STATE_OFF_CAMPUS_NOT_FAMILY") &&
      coa?.value
    ) {
      // coa -inStateTutionFee + outStateTutionFee
      let outStateFee = outStateTutionFee?.value
        ? outStateTutionFee?.value
        : inStateTutionFee?.value;
      let InStateFee = inStateTutionFee?.value
        ? inStateTutionFee?.value
        : outStateTutionFee?.value;
      collegeWebsiteAmount =
        Number(coa.value) -
        Number(InStateFee ? InStateFee : 0) +
        Number(outStateFee ? outStateFee : 0);
    }
    // if(residenceInOutState=="OUT_STATE_OFF_CAMPUS_NOT_FAMILY")
    // {
    //   collegeWebsiteAmount=coa.value - inStateTutionFee.value + outStateTutionFee.value
    // }

    if (residenceInOutState == "OUT_STATE_OFF_CAMPUS_FAMILY" && coa?.value) {
      let outStateFee = outStateTutionFee?.value
        ? outStateTutionFee?.value
        : inStateTutionFee?.value;
      let InStateFee = inStateTutionFee?.value
        ? inStateTutionFee?.value
        : outStateTutionFee?.value;
      collegeWebsiteAmount =
        Number(coa.value) -
        Number(InStateFee ? InStateFee : 0) +
        Number(outStateFee ? outStateFee : 0) -
        Number(roomAndBoardFee?.value);
    }
    return collegeWebsiteAmount;
  }

  private openAwardLetterDialog = this.dialogService.open<any>(
    new PolymorpheusComponent(AwardletterpopupComponent, this.injector),
    {
      data: "",
      dismissible: false,
      label: "",
      size: "l",
    }
  );

  openAwardLetter(awardletterid: string) {
    this.openAwardLetterDialog = this.dialogService.open<any>(
      new PolymorpheusComponent(AwardletterpopupComponent, this.injector),
      {
        data: awardletterid,
        dismissible: false,
        size: "l",
      }
    );
    this.openAwardLetterDialog.subscribe({
      next: (data: any) => {},
      complete: () => {},
    });
  }

  addcommas(num) {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
}
